<template>
    <div class="index">
        <div class="flash">
            <div class="gg">
                <div><div class="topNav">解决方案</div></div>
                <div class="title">健康行业</div>
                <div class="minTitle">通过整合不同业务系统中数据，连接孤岛，提高数字资产价值。多角度分析、全方位集成，迅速准确地定位业务与管理短板所在。通过前端可视化工具聚焦重点，满足多层次管理需求。</div>
                <!-- <div class="button">咨询详情</div> -->
            </div>
        </div>
        <picture>
            <source srcset="@/assets/images/jk1_mb.jpg" media="(max-width:768px)" alt="">
            <img class="flashImg" src="@/assets/images/jk1.png" />
        </picture>
       <div class="lxwm bg1">
            <div class="content">
                <div class="title1 tc">方案优势</div>
                <div class="items mt5 tc">
                    <div class="item2">
                        <div class="tc">
                            <img src="@/assets/images/jk2.png" />
                        </div>
                        <div class="minTitle2 mt5">增加收入</div>
                    </div>
                    <div class="item2">
                        <div class="tc">
                            <img src="@/assets/images/jk3.png" />
                        </div>
                        <div class="minTitle2 mt5">降低成本</div>
                    </div>
                    <div class="item2">
                        <div class="tc">
                            <img src="@/assets/images/jk4.png" />
                        </div>
                        <div class="minTitle2 mt5">提高盈利能力</div>
                    </div>
                    <div class="item2 item3">
                        <div class="tc">
                            <img src="@/assets/images/jk5.png" />
                        </div>
                        <div class="minTitle2 mt5">提高资金使用效率</div>
                    </div>
                </div>
            </div>
       </div>
       <div class="botton">
            <div class="content">
                <div class="leftImg">
                    <div class="myTityle">舟恩医药行业商业智能解决方案</div>
                    <div class="navDiv">
                        <div class="left">
                            <div class="item">驾驶舱</div>
                            <div class="item">经营主题</div>
                            <div class="item">生产分析</div>
                            <div class="item">分销分析</div>
                            <div class="item">零售分析</div>
                            <div class="item">重点产品分析</div>
                            <div class="item">库存周转分析</div>
                        </div>
                        <div class="left">
                            <div class="item">盈利能力分析</div>
                            <div class="item">成本费用分析</div>
                            <div class="item">资产效率分析</div>
                            <div class="item">资金管理分析</div>
                            <div class="item">风险预警分析</div>
                            <div class="item">绩效分析</div>
                        </div>
                    </div>
                </div>
                <div class="rightCon">
                    <img src="@/assets/images/jk7.png" />
                </div>
            </div>
       </div>
    </div>
</template>
<script>
    export default {
        components: {
        },
        data() {
            return {
                
            }
        },
        methods: {
            
        }
    }
</script>

<style lang="less" scoped>
    .index {
        .flashImg {
            width: 100%;
            height: calc(30w);
        }
        .botton {
            // min-height: 480px;
            background: url(../../assets/images/jk6.png) no-repeat;
            background-size: cover;
            zoom: 1px;
            overflow: hidden;
            padding: 40px 0;
            .leftImg {
                float: left;
                width: 40%;
                margin-left: 1%;
                .myTityle {
                    font-size: 20px;
                    color: #ffffff;
                    margin-top: 40px;
                    padding-bottom: 20px;
                }
                .navDiv {
                    zoom: 1;
                    overflow: hidden;
                    .left {
                        float: left;
                        width: 40%;
                        .item {
                            background: url(../../assets/images/rpa17.png) no-repeat;
                            background-size: auto 60%;
                            background-position-y: center;
                            text-indent: 17px;
                            color: #ffffff;
                            font-size: 12px;
                            margin-top: 10px;
                        }
                    }
                }
            }
            .rightCon {
                float: right;
                width: 63%;
                img {
                    width: 100%;
                    height: auto;
                }
            }
        }
        .lxwm {
            padding: 30px 0;
            .items {
                display: flex;
                flex-wrap: wrap;
                .item2 {
                    margin-top: 20px;
                    width: 19.49%;
                    background-color: #ffffff;
                    margin-right: 2%;
                    padding: 15px 2% 25px;
                    img {
                        width: auto;
                        height: 52px;
                        margin: 20px 0;
                    }
                    .minTitle2 {
                        color: #333333;
                        line-height: 20px;
                        font-size: 16px !important;
                    }
                }
                .item3 {
                    margin-right: 0;
                    
                }
            }
        }
    }
</style>
<style lang="less" scoped>
@media (max-width: 1230px) {
  .index {
    .flash {
      position: relative;
      padding: 0 50px;
      .gg .title {
        font-size: 24px;
      }
    }
    .flashImg {
      height: 100vh;
    }
  }
}
@media (max-width: 960px) {
  .index {
    .flash {
      .gg {
        color: #fff;
        .title {
          font-size: 20px;
        }
        .minColor2 {
            color: #fff;
            border-color: #fff;
        }
        .minTitle {
          width: 100%;
          font-size: 13px;
        }
        .button {
          padding: 6px 15px;
          margin-top: 20px;
        }
      }
    }
    .botton {
        .content {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .leftImg {
                .myTityle {
                    margin-top: 0;
                    padding-bottom: 20px;
                    font-size: 18px;
                }
            }
            .rightCon {
                width: 55%;
            }
        }
    }
  }
}
@media (max-width: 768px) {
    .index {
        .flash {
            padding: 0 15px;
            .minTitle {
                width: 50%;
                font-size: 13px;
                color: #fff;
                margin-top: 26px;
                padding-right: 20px;
                box-sizing: border-box;
            }
            .gg {
                top: 50px;
                .title {
                    font-size: 20px;
                    margin-top: 26px;
                }
                .button {
                    padding: 6px 15px;
                    margin-top: 20px;
                }
            }
            
        }
        .flashImg {
            height: 40vh;
        }
        .lxwm {
            .title1 {
                margin: 0;
                margin-bottom: 30px;
            }
            .items {
                flex-wrap: wrap;
                justify-content: space-between;
                background-color: #fff;
                .item2 {
                    width: 45%;
                    margin: 0;
                    padding: 25px 0;
                    box-sizing: border-box;
                    .tc img {
                        height: 40px;
                        margin: 10px 0 0;
                    }
                    .minTitle2 {
                        font-size: 14px !important;
                    }   
                }
            }
        }
        .botton {
            .content {
                flex-wrap: wrap;
                .leftImg {
                    width: 100%;
                    padding: 0 25px;
                    margin-bottom: 25px;
                    .myTityle {
                        padding-bottom: 15px;
                        font-size: 20px;
                        text-align: center;
                    }
                    .navDiv .left {
                        width: 50%;
                        .item {
                            text-indent: 17px;
                            width: 100%;
                            font-size: 14px;
                            margin-top: 10px;
                            margin-right: 0;
                        }
                    }
                }
                .rightCon {
                    width: 100%;
                }
            }
        }
    }
}
</style>